module.exports = __webpack_public_path__ + "img/47-Chêne des Montagnes.jpg";